
import { Base } from '../base-component';

import './sitemap.component.scss';

import * as _ from 'lodash';

import * as $ from 'jquery';


export class SitemapComponent extends Base {


    constructor(element: Element) {
        super(element);
    }

    init() {
    }

    bindEvents() {

    }

}



// WEBPACK FOOTER //
// ./components/sitemap/sitemap.component.ts